export default "__VITE_ASSET__C8wf$6_6__"